import React from "react";
import { InputNumber } from "primereact/inputnumber";
import { Button } from "primereact/button";

// Seed input for the image pages. Empty = the server picks a random seed and
// sends it back with the image (lastSeed); "Reuse" puts that seed in the field,
// so a result the user likes can be made again or fine-tuned one change at a time.
export default function SeedField({ id, value, onChange, lastSeed, disabled }) {
  return (
    <div className="p-field">
      <label htmlFor={id}>Seed (empty = random)</label>
      <InputNumber inputId={id} value={value} onValueChange={(e) => onChange(e.value)} useGrouping={false}
                   min={0} max={4294967295} disabled={disabled} />
      {lastSeed != null && (
        <small style={{ display: "flex", alignItems: "center", gap: 4, marginTop: 4, color: "#64748b" }}>
          Last image: seed {lastSeed}
          {lastSeed === value ? " (in the field)" : (
            <Button label="Reuse" icon="pi pi-replay" className="p-button-text p-button-sm"
                    style={{ padding: "0 4px" }} disabled={disabled} onClick={() => onChange(lastSeed)} />
          )}
        </small>
      )}
    </div>
  );
}
